<template>
    <div class="main-container">
        <h3>Upload Form 16 and General Documents</h3>
        <div>
          <div class="option-container">
            <tl-select
              class="content-width"
              label="Document Type*"
              name="documentType"
              v-model="documentType"
              labelText="name"
              :multiple="false"
              :options="docTypeList"
              @change="handleDocumentTypeChange"
              data-vv-as="Document Type"
              v-validate="{required: true}"
              :classname="errors.has('documentType')"
              :errormsg="errors.first('documentType')"
            />
            <tl-select
              v-if="ddValue != 'general'"
              class="content-width"
              label="Financial Year*"
              name="paymentYear"
              v-model="paymentYear"
              :multiple="false"
              :options="paymentYearList"
              @change="(val)=>paymentYear = val"
              data-vv-as="Payment Year"
              v-validate="{required: true}"
              :classname="errors.has('paymentYear')"
              :errormsg="errors.first('paymentYear')"
            />
            <tl-select
            v-if="ddValue == 'general'"
            class="content-width"
            label="Document List*"
            name="documentList"
            :multiple="false"
            :options="DocumentList"
            @change="(val)=>document = val"
            data-vv-as="Payment Year"
            v-validate="{required: true}"
            :classname="errors.has('document')"
            :errormsg="errors.first('document')"
        />
        <button v-if="ddValue == 'general'" style="margin-top: 25px;" class="refresh" @click="openAddDocumentDialog">Add</button>
          </div>
          <div  class="option-container">
            <div class="content-width">
              <div class="download-btn-container">
                <img src="@/assets/download.svg"  class="img" />
                <a class="text" href="https://payliefprod-client-logos.s3.ap-south-1.amazonaws.com/templates/Form16_Upload_Template.xlsx">Download Template</a>
              </div>
              <p style="font-weight: 500; font-size: 0.9rem;">Upload Excel File</p>
              <upload :maxSize="10485800" :tobucket="false" name="bulkExcelFile"  @change="onUploadExcelTemplate($event)"></upload>
              <p style="color: #FF0000;font-weight: 500;margin-top:10px;">Note: Zip File Should be less than 10Mb</p>
            </div>
            <div class="content-width">
              <p style="font-weight: 500; font-size: 0.9rem;margin-top: 24px;">Upload Zip File</p>
              <upload :maxSize="104858000" :tobucket="false" name="bulkZipFile"  @change="onUploadZipTemplate($event)"></upload>
              <p style="color: #FF0000;font-weight: 500;margin-top:10px;">Note: Zip File Should be less than 100Mb</p>
            </div>
            <button class="mt-2 mb-2 customButton"  @click="upload">Upload</button>
          </div>
          <div class="table-container">
            <button class="refresh" @click="refreshData">Refresh</button>
            <data-table 
              :columns="uploadColumnNames" 
              :tableData="uploadDataDetails"
              :checkbox="false"
              :withForm="false"
              :showhistory="false"
              :showedit="false"
              :showdelete="false"
            >
            <template v-slot:rowcontent="slotprops">
              <p
                v-if="
                  slotprops.value.column.key != 'type' &&
                  slotprops.value.column.key != 'download'"
              >
                {{ slotprops.value.record[slotprops.value.column.key] }}
              </p>
              <div class="text-capital" v-if="slotprops.value.column.key == 'type'">
                <span>{{ fileTypeEnums[slotprops.value.record.type] || slotprops.value.record.type }}</span>
              </div>
              <p class="download-icon" @click="downloadUrl(slotprops.value.record)" v-if="slotprops.value.column.key == 'download'">
                <img src="@/assets/DownloadEss.svg" alt="">
                <span>Download Logs</span>
              </p>
            </template>
          </data-table>
          </div>
        </div>
        <pop-up-message
          v-if="showErrorPopup"
          :message="`Upload is Processing`"
          btnText="OK"
          @back="gotoBack()"
        ></pop-up-message>
        <pop-up-message
          v-if="showUploadSuccessPopup"
          :message="`File uploaded successfully`"
          btnText="OK"
          @back="closeUploadSuccessPopup()"
        ></pop-up-message>
        <pop-up-message
          v-if="showSuccessPopup"
          :message="`Document List added successfully`"
          btnText="OK"
          @back="goBackToDocument()"
        ></pop-up-message>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <v-dialog v-model="dialogAddDocument" persistent max-width="600px" >
      <v-card style="padding: 10px;">
        <v-card-title style="font-size: 24px;">Add Document Name</v-card-title>
        <v-divider color="#34c0be"></v-divider> 
        <v-card-text>
        <txt
            v-model="newDocumentName"
            label="Enter Document Name"
            style="font-weight: dark;"      
            type="text"

          ></txt>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="#5d409f darken-1" text @click="closeAddDocumentDialog">Cancel</v-btn>
          <v-btn color="#5d409f darken-1" text @click="addDocument">Add</v-btn> -->
          <btn-grp class="form-button">
                <btn
                  text="Cancel"
                  @click="closeAddDocumentDialog"
                  type="secondary"
                  
                />
                <btn
                  text="Add"
                  type="primary"
                  @click="addDocument"
                />
              </btn-grp>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data(){
    return{
    ddValue: '',
      employeeLopData:[],
      newDocumentName:'',
      toast:false,
      errmsg:'',
      paymentYear: '',
      document:'',
      paymentMonth: '',
      documentType: null,
      excel_file: '',
      dialogAddDocument: false,
      zip_file: '',
      fileTypeEnums: {
        part_A: "PART A",
        part_B: "PART B",
        consolidated: "Consolidated",
        general:"General"
      },
      docTypeList: [{name:"PART A", value: "part_A"}, {name:"PART B", value: "part_B",},{name: 'Consolidated', value:'consolidated'},{name: 'General', value: 'general'}],
      tabs: [{
          header: 'Update LOP & RLOP'
        },
        {
          header: 'Employees List'
        }
      ],
      paymentYearList: [],
      DocumentList:[],
      paymentMonthList: ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'],
      showErrorPopup: false,
      showSuccessPopup: false,
      showUploadSuccessPopup: false,
      logSheetUrl: null,
      uploadColumnNames: [
        { 
          label: "File Type",
          key: "type"
        },
        {
          label: "File Name",
          key: "file_name"
        },
        {
          label: "Status",
          key: "status"
        },
        {
          label: "Download Log Details",
          key: "download"
        }
      ],
      uploadDataDetails: []
    }
  },
  mounted(){
    const today = new Date();
    const currentYear = today.getFullYear();
    const previousFiveYears = [];
    for (let i = 1; i < 5; i++) {
      previousFiveYears.push(currentYear - i);
    }
    this.paymentYearList = previousFiveYears;
    this.getUploadFormsixLogs();
    this.getDocumentList();
  },
  activated(){
    
  },
  computed: {
    ...mapState({
      entities: state => state.onboard.legal_entities.data
    }),

    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    showPaymentYear() {
      return this.documentType && this.documentType !== 'general';
    },
    showDocumentList() {
      return this.documentType === 'general';
    }
  },
  watch: {
    documentType(newVal) {
      if (newVal === 'general') {
        this.paymentYear = null;
      }
    }
  },
  methods:{
    ...mapActions({
      act_upload_form_general: "dashboard/organisation/utilities/itsheetandpayslip/uploadFormAndGeneral",
      act_upload_general: "dashboard/organisation/utilities/itsheetandpayslip/uploadGeneral",
      act_get_upload_logs: "dashboard/organisation/utilities/itsheetandpayslip/getUploadPreviousPayslipItsheetLogs",
      act_get_general_logs: "dashboard/organisation/utilities/itsheetandpayslip/getUploadGeneralLogs",
      act_get_form_logs: "dashboard/organisation/utilities/itsheetandpayslip/getUploadFormLogs",
      
      act_get_document_list: "dashboard/organisation/utilities/itsheetandpayslip/getDocumentList",
      act_get_add_document_list: "dashboard/organisation/utilities/itsheetandpayslip/addDocumentList",
      act_get_download_general: "dashboard/organisation/utilities/itsheetandpayslip/getDownloadGeneral",
      act_get_download_form: "dashboard/organisation/utilities/itsheetandpayslip/getDownloadForm",
    }),
  handleDocumentTypeChange(val) {
        this.ddValue = val.value;
        this.documentType = val;
    },
    onUploadExcelTemplate(event){
      this.excel_file = event;
    },

    onUploadZipTemplate(event){
      this.zip_file = event;
    },
    async getDocumentList() {
      try{
        let payload={
                    le_id:this.le_id
                }
     const response =  await this.act_get_document_list(payload)
        // if (response && response.data){
          this.DocumentList = response.data.data.map(doc => doc.documentName);
        // }
        }
     catch(error) {
        console.error("Error fetching document list:", error);
      };
    },
    async upload() {
    
          this.performAction();
     
    
    },

    gotoBack(){
      this.showErrorPopup = false;
      this.getUploadFormsixLogs();
    },
    closeUploadSuccessPopup(){
      this.showUploadSuccessPopup = false;
      this.getUploadFormsixLogs();
    },
    goBackToDocument(){
      this.showSuccessPopup = false;
      this.getDocumentList()
    },
    async addDocument() {
    if (this.newDocumentName.trim() === "") {
      this.toast = true;
      this.errmsg = "Document Name is required";
      return;
    }

    const payload = {
      documentName: this.newDocumentName,
      le_id: this.le_id
    };

    try {
      let res = await this.act_get_add_document_list(payload);
      if (res && res.data && res.data.statusCode) {
        this.showSuccessPopup = true
        this.closeAddDocumentDialog();
        this.getDocumentList();
      }
      this.closeAddDocumentDialog();
    } catch (error) {
      this.toast = true;
      this.errmsg = error;
    }
  },
  async downloadUrl(item) {
  try {
    let res;
    if (this.ddValue === 'general') {
      res = await this.act_get_download_general(item.Id);
    } else {
      res = await this.act_get_download_form(item.Id);
    }
    
    if (res && res.data && res.data.data) {
      const link = document.createElement("a");
      link.href = res.data.data;
      link.setAttribute("download", "salaryRevisionTemplate.xlsx"); // or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Remove the link after download
    }
  } catch (error) {
    this.toast = true;
    this.errmsg = error;
  }
},

    refreshData(){
      this.getUploadFormsixLogs();
    },

    async getUploadFormsixLogs() {
      try {
        let res;
        if (this.ddValue === 'general') {
          res = await this.act_get_general_logs(this.le_id);
        } else {
          res = await this.act_get_form_logs(this.le_id);
        }
        if (res && res.data && res.data.data) {
          this.uploadDataDetails = res.data.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    openAddDocumentDialog() {
      this.dialogAddDocument = true;
    },

    closeAddDocumentDialog() {
      this.dialogAddDocument = false;
      this.newDocumentName = "";
    },

    async performAction(){
      let clientCode =  this.entities[this.$route.params.entity_index] ? this.entities[this.$route.params.entity_index].clientCode : null;
      let month = this.paymentMonth.toLowerCase();
      let formData = new FormData();
      formData.append("file1", this.excel_file);
      formData.append("file2", this.zip_file);
    //   formData.append("paymentYear", this.paymentYear);
      formData.append("legalEntityId", this.le_id);
      formData.append("clientCode", clientCode);
      // formData.append("type", this.documentType.value);

      
      if (this.ddValue !== 'general') {
        formData.append("paymentYear", this.paymentYear);
        formData.append("type", this.documentType.value);
        try {
          let res = await this.act_upload_form_general(formData);
          if (res && res.data && res.data.status) {
            this.showErrorPopup = true;
            this.logSheetUrl = res.data.data;
          }
          this.showUploadSuccessPopup = true;
          this.getUploadFormsixLogs()
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
        
      } else if (this.ddValue === 'general'){
        formData.append("documentList", this.document);
        formData.append("type", this.document);
        try {
          let res = await this.act_upload_general(formData);
          if (res && res.data && res.data.status) {
            this.showErrorPopup = true;
            this.logSheetUrl = res.data.data;
          }
          this.showUploadSuccessPopup = true;
        } catch (error) {
          this.toast = true;
          this.errmsg = error;
        }
      }
    }
  }
  
}
</script>

<style scoped lang="scss">
  .option-container{
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;
    margin-top: 20px;
  }

.customButton{
  display: block;
  border-radius: 4px;
  background-color: #5d409f;
  color: #ffffff;
  font-weight: bold;
  width:18%;
  min-height: 45px;
  padding: 14px;
  transition: all 0.5s ease;
}

.customButton:hover{
  opacity: 0.8;
}

.content-width{
  min-width: 20%;
}

.table-container{
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: end;
}

.refresh{
  background-color: #5d409f;
  color: #ffffff;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px 18px;
  margin-bottom: 10px;
  transition: all 0.5s ease;
}

.refresh:hover{
  opacity: 0.8;
}

.download-icon{
  display: flex; 
  align-items: center; 
  gap: 10px; 
  cursor: pointer;
}
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
</style>
